import RedirectionModal from './RedirectionModal';

export default RedirectionModal;
